import styled from "@emotion/styled";
import { bodyBold } from "../BodyBoldText";
import { mq } from "../../Theme";
// @todo: Use heading sizes from theme config via `props.theme.fontSize`
var Heading1 = /*#__PURE__*/ styled("h1", {
    target: "eyz28g40"
})(bodyBold, "  font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:", function(param) {
    var theme = param.theme;
    return theme.fontWeight.heading;
}, ";font-size:2.125rem;line-height:1.235em;padding-top:0.75rem;padding-bottom:0.75rem;", mq("lg"), "{font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.xl.size;
}, ";line-height:1.188em;}");
var Heading2 = /*#__PURE__*/ styled("h2", {
    target: "eyz28g41"
})(bodyBold, "  font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:", function(param) {
    var theme = param.theme;
    return theme.fontWeight.heading;
}, ";font-size:1.688rem;line-height:1.259em;padding-top:0.75rem;padding-bottom:0.75rem;", mq("lg"), "{font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.lg.size;
}, ";line-height:1.25em;}");
var Heading3 = /*#__PURE__*/ styled("h3", {
    target: "eyz28g42"
})(bodyBold, "  font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-weight:", function(param) {
    var theme = param.theme;
    return theme.fontWeight.heading;
}, ";font-size:1.375rem;line-height:1.273em;padding-top:0.75rem;padding-bottom:0.75rem;", mq("lg"), "{font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.md.size;
}, ";line-height:1.4em;}");
var Heading4 = /*#__PURE__*/ styled("h4", {
    target: "eyz28g43"
})(bodyBold);
var Heading5 = /*#__PURE__*/ styled("h5", {
    target: "eyz28g44"
})(bodyBold);
var Heading6 = /*#__PURE__*/ styled("h6", {
    target: "eyz28g45"
})(bodyBold);
export { Heading1, Heading2, Heading3, Heading4, Heading5, Heading6 };
